module.exports = __webpack_public_path__ + "img/molar-logo.7645af01.png";